import { CommentsoldIntegrationProduct } from "@redotech/redo-model/commentsold";
import * as z from "zod/v4";

export const getCommentsoldOAuthUrl = {
  name: "getCommentsoldOAuthUrl" as const,
  input: z.object({
    product: z.enum(CommentsoldIntegrationProduct),
    isStaging: z.boolean(),
    stagingEnv: z.string().optional(),
  }),
  output: z.object({ url: z.string() }),
};
